import React, { FC } from 'react';
import { observer } from 'mobx-react';
import { SupplierValidationDocument, SupplierValidationRecord } from '@mortee/domain/validationSystem';
import { SidePadding, TabTitle } from '@mortee/routes/validationSystem/editValidtionRecord/EditValidationRecordStyles';
import SupplierValidationRecordDocuments from '@mortee/routes/validationSystem/editValidtionRecord/mainTabs/SupplierValidationRecordDocuments';

interface Props {
  record: SupplierValidationRecord;
  className?: string;
  onDocumentClick?(document: SupplierValidationDocument): void;
}

const EditValidationRecordDocumentsTab: FC<Props> = observer((props) => {
  const { record, className, onDocumentClick } = props;

  return (
    <SidePadding className={className}>
      <TabTitle>Documents</TabTitle>
      <SupplierValidationRecordDocuments record={record} onDocumentClick={onDocumentClick} />
    </SidePadding>
  );
});

export default EditValidationRecordDocumentsTab;
